<template>
  <div class="pages">
    <navTop :acIndex="1"></navTop>
    <div class="box">
      <!-- 内容 -->
      <div class="box-main">
        <div class="empty" v-if="categorylist.length == 0">
          <img src="https://www.mescroll.com/img/mescroll-empty.png" />
          <p>Collection list is empty</p>
        </div>
        <div
            v-else
            class="box-main-item"
            v-for="(item, index) in categorylist"
            :key="index"
            @click="goDetails(item.serveId)"
        >
          <img :src="item.icon" />
          <p class="jys" v-if="item.level == 0">Junior inspector</p>
          <p class="jys" v-if="item.level == 1">Intermediate inspector</p>
          <p class="jys" v-if="item.level == 2">Senior inspector</p>
          <p class="jys" v-if="item.level == 3">Expert inspector</p>
          {{ item.level }}
          <p class="name">{{ item.name }}</p>
          <p class="order">{{ item.count || 0 }}</p>
          <p class="age">{{ item.workYear }}year</p>
          <p class="star">{{ item.score }}branch</p>
          <p class="money">{{ parseInt(item.price) || 0 }}</p>
        </div>
      </div>
    </div>
    <navFooter></navFooter>
  </div>
</template>

<script>
import navTop from "../../components/navTop.vue";
import navFooter from "../../components/navFooter.vue";

export default {
  name: "collection",
  components: {
    navTop,
    navFooter,
  },
  data() {
    return {
      categorylist: [],
    };
  },
  created() {
    if (!sessionStorage.getItem("uid")) {
      this.$router.push({path: "/"});
    } else {
      this.getCategorylist();
    }
  },
  methods: {
    // 收藏列表
    getCategorylist() {
      let data = {
        uid: sessionStorage.getItem("uid"),
        nowPage: 1,
        pageCount: 10000,
      };
      this.$api.categorylist(data).then((res) => {
        console.log(res);
        if (res.result == 0) {
          this.categorylist = res.data.list;
        }
      });
    },
    goDetails(id) {
      this.$router.push({path: "/detail", query: {id: id}});
    },
  },
};
</script>

<style lang="scss" scoped>
// 科技蓝色风格变量 - 使用 #1ba8e8 作为主色调
$blue-primary: #1ba8e8;
$blue-primary-rgba: rgba(27, 168, 232, 0.9);
$blue-secondary: #4ab9f0;
$blue-glow: rgba(27, 168, 232, 0.4);
$blue-light: rgba(27, 168, 232, 0.2);
$blue-dark: #0f2b3f;
$text-glow: 0 0 8px rgba(27, 168, 232, 0.5);

.pages {
  background: linear-gradient(135deg, #0f2b3f 0%, #1a3f5a 100%);
  position: relative;
  min-height: 10vh;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: radial-gradient(circle at 20% 30%, rgba(27, 168, 232, 0.1) 0%, transparent 50%);
    pointer-events: none;
  }

  .box {
    margin: 0 auto 100px;
    max-width: 1400px;
    padding: 0 20px;
    position: relative;
    z-index: 2;

    // 内容
    .box-main {
      margin-top: 30px;
      width: 100%;
      border: 1px solid $blue-primary-rgba;
      border-radius: 35px;
      padding: 40px 30px 30px 30px;
      box-sizing: border-box;
      display: flex;
      flex-wrap: wrap;
      gap: 20px;
      background: rgba(15, 43, 63, 0.6);
      backdrop-filter: blur(10px);
      box-shadow: 0 0 30px $blue-glow;

      .empty {
        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        img {
          display: block;
          opacity: 0.7;
          filter: drop-shadow(0 0 15px $blue-glow);
        }

        p {
          color: $blue-primary;
          font-size: 25px;
          font-weight: bold;
          padding: 30px 0;
          box-sizing: border-box;
          text-shadow: $text-glow;
        }
      }

      .box-main-item {
        width: calc(25% - 15px);
        min-width: 280px;
        height: 200px;
        background: linear-gradient(135deg, rgba(27, 168, 232, 0.1) 0%, rgba(15, 43, 63, 0.9) 100%);
        border: 1px solid $blue-primary-rgba;
        border-radius: 16px;
        margin-bottom: 0;
        margin-right: 0;
        position: relative;
        box-shadow: 0 0 20px $blue-glow;
        transition: all 0.3s ease;
        overflow: hidden;

        &:hover {
          transform: translateY(-5px);
          box-shadow: 0 8px 30px $blue-primary;
          border-color: $blue-primary;
        }

        img {
          width: 85px;
          height: 85px;
          background: linear-gradient(135deg, $blue-primary 0%, #fff 100%);
          border-radius: 50%;
          position: absolute;
          top: 20px;
          left: 20px;
          border: 2px solid $blue-primary;
          box-shadow: 0 0 20px $blue-primary;
          object-fit: cover;
        }

        .jys {
          min-width: 100px;
          padding: 4px 10px;
          background: rgba(27, 168, 232, 0.25);
          border: 1px solid $blue-primary-rgba;
          border-radius: 20px;
          font-size: 12px;
          font-weight: 600;
          color: #ffffff;
          text-align: center;
          position: absolute;
          bottom: 15px;
          left: 20px;
          box-shadow: 0 0 12px $blue-glow;
          white-space: nowrap;
          letter-spacing: 0.5px;
          backdrop-filter: blur(2px);
        }

        .name {
          font-size: 16px;
          font-weight: bold;
          color: #ffffff;
          text-shadow: 0 0 10px $blue-primary;
          position: absolute;
          top: 25px;
          left: 120px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          max-width: calc(100% - 140px);
        }

        .order {
          font-size: 14px;
          color: #c0e4ff;
          position: absolute;
          top: 55px;
          left: 120px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          max-width: calc(100% - 140px);
          font-weight: 400;
          opacity: 0.95;
        }

        .age {
          font-size: 14px;
          color: #c0e4ff;
          position: absolute;
          top: 80px;
          left: 120px;
          font-weight: 400;
          opacity: 0.95;
        }

        .star {
          font-size: 14px;
          color: #c0e4ff;
          position: absolute;
          top: 105px;
          left: 120px;
          font-weight: 400;
          opacity: 0.95;
        }

        .money {
          font-size: 14px;
          color: $blue-primary;
          position: absolute;
          top: 130px;
          left: 120px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          max-width: calc(100% - 140px);
          font-weight: 600;
          opacity: 0.95;
        }
      }
    }
  }
}

// 底部样式
::v-deep .footer {
  background: linear-gradient(90deg, #0f2b3f 0%, #1a3f5a 100%) !important;
  border-top: 2px solid $blue-primary !important;
  box-shadow: 0 -5px 25px $blue-glow !important;
  position: relative;
  z-index: 2;

  .footer-left {
    .logo {
      filter: drop-shadow(0 0 10px $blue-primary);
    }

    .text {
      color: #c0e4ff !important;

      span {
        color: $blue-primary !important;
        text-shadow: $text-glow;
      }
    }
  }

  .footer-right {
    .service {
      .title {
        color: $blue-primary !important;
        text-shadow: $text-glow;
      }

      .list {
        .li {
          color: #c0e4ff !important;

          &:hover {
            color: $blue-primary !important;
            text-shadow: $text-glow;
          }
        }
      }
    }

    .contact {
      .title {
        color: $blue-primary !important;
        text-shadow: $text-glow;
      }

      .item {
        color: #c0e4ff !important;

        img {
          filter: brightness(1.2) drop-shadow(0 0 5px $blue-primary);
        }
      }
    }

    .qrcode {
      border: 1px solid $blue-primary !important;
      box-shadow: 0 0 20px $blue-glow;
    }
  }

  // 其他网站区域
  .other-site {
    border-top: 1px solid rgba(27, 168, 232, 0.3) !important;
    margin-top: 30px !important;
    padding-top: 30px !important;

    .other-site-title {
      color: $blue-primary !important;
      font-size: 18px !important;
      font-weight: bold !important;
      margin-bottom: 15px !important;
      text-shadow: $text-glow;
      position: relative;
      display: inline-block;

      &::after {
        content: '';
        position: absolute;
        bottom: -5px;
        left: 0;
        width: 50px;
        height: 2px;
        background: $blue-primary;
        box-shadow: 0 0 10px $blue-primary;
      }
    }

    .other-site-links {
      display: flex !important;
      flex-wrap: wrap !important;
      gap: 15px !important;
      margin-bottom: 20px !important;

      .other-site-link-item {
        color: #c0e4ff !important;
        font-size: 14px !important;
        padding: 5px 15px !important;
        border: 1px solid rgba(27, 168, 232, 0.2) !important;
        border-radius: 20px !important;
        transition: all 0.3s ease !important;
        cursor: pointer !important;

        &:hover {
          border-color: $blue-primary !important;
          box-shadow: 0 0 15px $blue-glow !important;
          color: $blue-primary !important;
          transform: translateY(-2px);
        }
      }
    }

    .other-site-copyright {
      color: #c0e4ff !important;
      font-size: 13px !important;
      line-height: 1.8 !important;
      text-align: center !important;

      a {
        color: $blue-primary !important;
        text-decoration: none !important;
        transition: all 0.3s ease !important;

        &:hover {
          color: lighten($blue-primary, 20%) !important;
          text-shadow: $text-glow;
        }
      }

      .icp {
        color: #c0e4ff !important;
        margin: 0 5px;

        span {
          color: $blue-primary !important;
        }
      }

      .beian {
        color: #c0e4ff !important;
        margin: 0 5px;

        a {
          color: $blue-primary !important;
        }
      }

      .company {
        color: $blue-primary !important;
        font-weight: bold;
      }
    }
  }
}

// 响应式调整
@media screen and (max-width: 1200px) {
  .pages {
    .box {
      padding-left: 15px;
      padding-right: 15px;

      .box-main {
        padding: 30px 20px 20px;

        .box-main-item {
          width: calc(33.333% - 14px);
          min-width: 250px;
          height: 190px;

          img {
            width: 75px;
            height: 75px;
            top: 15px;
            left: 15px;
          }

          .jys {
            font-size: 11px;
            padding: 3px 8px;
            bottom: 12px;
            left: 15px;
          }

          .name {
            font-size: 15px;
            left: 105px;
            max-width: calc(100% - 120px);
          }

          .order, .age, .star, .money {
            font-size: 13px;
            left: 105px;
          }

          .order {
            top: 48px;
          }

          .age {
            top: 71px;
          }

          .star {
            top: 94px;
          }

          .money {
            top: 117px;
          }
        }
      }
    }
  }
}

@media screen and (max-width: 768px) {
  .pages {
    .box {
      .box-main {
        .box-main-item {
          width: calc(50% - 10px);
        }
      }
    }
  }
}
</style>